import { ApprovalStatus, Task, UserRole } from '@css-xp/apd-common';

export enum TaskAction {
  APPROVE = 'Approve',
  DECLINE = 'Decline',
  REQUEST_REASONS = 'Request supporting reasons',
  REPLY = 'Support with reasons',
  COMMENT = 'Comment',
  CANCEL_REQUEST = 'Cancel request',
  ASSIGN_TASK = 'Assign to me',
  UNASSIGN_TASK = 'Unassign request',
  CHANGE_ASSIGNEE = 'Change assignee',
}

export const isActionAllowed = (action: TaskAction, task: Task, role?: UserRole | null, userId?: string) => {
  const isOpenTask =
    task.approvalStatus &&
    [
      ApprovalStatus.IN_REVIEW,
      ApprovalStatus.WAITING_FOR_REVIEW,
      ApprovalStatus.REASONS_PROVIDED,
      ApprovalStatus.REASONS_REQUESTED,
    ].includes(task.approvalStatus);
  const isApprover = role && [UserRole.APPROVER].includes(role);
  const isSuperUser = role && [UserRole.SUPERUSER].includes(role);
  const isAssignee = task.assigneeId === userId;
  const isOwner = task.ownerId === userId;
  const hasOwner = task.ownerId;
  const isInitiator = task.initiatorId === userId;
  const isTaskWaitingForReview = task.approvalStatus === ApprovalStatus.WAITING_FOR_REVIEW;
  const areReasonsRequested = task.approvalStatus === ApprovalStatus.REASONS_REQUESTED;
  switch (action) {
    case TaskAction.APPROVE:
    case TaskAction.DECLINE:
      if (isSuperUser) {
        return isOpenTask;
      }
      return isApprover && isOwner && isOpenTask && !isTaskWaitingForReview;
    case TaskAction.UNASSIGN_TASK:
      if (isSuperUser) {
        return false;
      }
      return isApprover && isOwner && isOpenTask && !isTaskWaitingForReview;
    case TaskAction.REQUEST_REASONS:
      if (isSuperUser) {
        return isOpenTask && !areReasonsRequested;
      }
      return isApprover && isOwner && isOpenTask && !areReasonsRequested && !isTaskWaitingForReview;
    case TaskAction.REPLY:
      return isInitiator && isAssignee && isOpenTask && areReasonsRequested;
    case TaskAction.COMMENT:
      return isOpenTask;
    case TaskAction.CANCEL_REQUEST:
      return isInitiator && isOpenTask;
    case TaskAction.ASSIGN_TASK:
      if (isSuperUser) {
        return false;
      }
      return isApprover && !hasOwner && isOpenTask;
  }
};
